import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as toastr from 'toastr';
const classNames = require('classnames');

import paymentActions from './paymentActions';

import CardDetails from './CardDetails';
import PaymentDetailsForm from './PaymentDetailsForm';
import { Button } from '../components/buttons';

interface Props {
	className?: string;
	card: StripeCard;
	customer: UserDetails;
	details: any;
	stripe: any;
	actions: any;
}
interface State {
	isLoading: boolean;
}
class UpdatePaymentDetails extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: false
		};
	}

	componentDidMount() {
		this.props.actions.fetchCustomerCard(this.props.customer.id);
	}

	makePayment = () => {
		this.setState({ isLoading: true });
		this.props.stripe
			.createToken({ name: this.props.details.ccCardholderName })
			.then((result: any) => {
				if (result.error) {
					toastr.error(result.error.message);
				} else {
					// Send the token to server
					return this.props.actions.updateCustomerCard(this.props.customer.stripeCustomerId, result.token).then(() => {
						toastr.success('Card successfully updated!');
					});
				}
			})
			.then(() => this.setState({ isLoading: false }));
	}

	render() {
		const { className } = this.props;
		return (
			<div className={classNames('', className)}>
				<h2 className="form-fieldset-title">Current card</h2>
				<div className="form-fieldset mb-4">
					<CardDetails card={this.props.card} />
				</div>
				<h2 className="form-fieldset-title">New card</h2>
				<div className="form-fieldset">
					<PaymentDetailsForm details={this.props.details} actions={this.props.actions} />
				</div>
				<Button className="btn-primary mt-4" type="button" onClick={this.makePayment} disabled={this.state.isLoading}>
					Update card
				</Button>
			</div>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		details: state.payment.details,
		stripe: state.payment.stripe,
		customer: state.user.user,
		card: state.payment.card
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...paymentActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(UpdatePaymentDetails);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/payment/UpdatePaymentDetails.tsx